<!-- eslint-disable @angular-eslint/template/alt-text -->
<ion-header>
  <ion-toolbar mode="ios" color="transparent" class="messageModal__toolbar">
    <ion-buttons slot="start">
      <ion-button (click)="dismissModal()">
        <ion-icon slot="icon-only" name="close" color="white" />
      </ion-button>
    </ion-buttons>

    <ion-title>
      <ion-icon class="messageModal__logo" [src]="ICON.NC_LOGO" color="white" />
    </ion-title>
  </ion-toolbar>

  <div class="messageModal__confettiBox" #confetti></div>

  <div class="messageModal__opacityOverlay">
    @if (message.style === MessageStyle.STATUS) {
      <div class="messageModal__iconStatus">
        <app-cycler-status [cyclerStatus]="cyclerStatus" />
      </div>
    }

    @for (media of message.media; track media) {
      @if (media.type === MediaType.ICON && (lang$ | async); as lang) {
        <div class="messageModal__icon {{ 'special-' + media.url }}">
          <img src="{{ './assets/img/icons/special/special-' + media.url + '.svg' }}" />
        </div>
      }
      <h2 class="messageModal__title">{{ media.title }}</h2>
    }

    @if (message.style === MessageStyle.STATUS) {
      <h2 class="messageModal__title">
        {{ 'txt-you-are-a' | tmd | stripTags }} {{ cyclerStatus | cyclerStatus }}
      </h2>
    }
  </div>
</ion-header>

<ion-content class="messageModal__content">
  <div class="ion-padding">
    <div [innerHTML]="markdownService.parse(message.msg) | safe"></div>
  </div>
</ion-content>

<ion-footer class="messageModal__footer">
  @if (message.style === MessageStyle.STATUS) {
    <div>
      @if (isCapacitor) {
        <ion-button expand="block" shape="round" (click)="shareCyclerStatus()">
          <ion-label>{{ 'txt-share' | tmd | stripTags }}</ion-label>
        </ion-button>
      } @else {
        <ion-button expand="block" shape="round" (click)="dismissModal()">
          <ion-label>{{ 'txt-understand' | tmd | stripTags }}</ion-label>
        </ion-button>
      }
    </div>
  } @else {
    <ion-button expand="block" shape="round" (click)="dismissModal()">
      <ion-label>{{ 'txt-understand' | tmd | stripTags }}</ion-label>
    </ion-button>
  }
</ion-footer>
